/**
 * Local performance marks for the loading project (Stage 3, 2026-10-31).
 *
 * Compiled in only when REACT_APP_PERF_MARKS=true is set at build/start
 * time; production builds leave the variable unset, so every call below is
 * a no-op there. With the flag on, each call is one `performance.mark`
 * (microseconds, no allocation beyond the entry, no network, no storage,
 * no personal data: names only). Read them in DevTools with
 *   performance.getEntriesByType('mark').map(m => [m.name, Math.round(m.startTime)])
 *
 * Marks:
 *   pxc:auth-resolved                 first Firebase auth callback (user or null)
 *   pxc:dashboard-requests-start      the dashboard's signed-in loaders start
 *   pxc:trade-opportunities-data      Trade Opportunities rows arrived
 *   pxc:trade-opportunities-commit    those cards are in the DOM
 *   pxc:active-strip-data             Active Trades & Purchases strip data arrived
 */
const ENABLED = process.env.REACT_APP_PERF_MARKS === 'true';

export function perfMark(name) {
  if (!ENABLED) return;
  try {
    if (typeof performance !== 'undefined' && typeof performance.mark === 'function') performance.mark(name);
  } catch { /* marks are best-effort */ }
}
